import { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { ensureConfig, getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';

import { useModel } from '@src/generic/model-store';
import { getCourseDiscussionTopics } from '../../data/thunks';
import messages from '../sidebar/sidebars/discussions/messages';

ensureConfig(['DISCUSSIONS_MFE_BASE_URL']);

const InlineDiscussions = ({ courseId, unitId }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const { tabs } = useModel('courseHomeMeta', courseId);
  const topic = useModel('discussionTopics', unitId);
  const baseUrl = getConfig().DISCUSSIONS_MFE_BASE_URL;
  const hasDiscussionsTab = useMemo(
    () => tabs?.some(tab => tab.slug === 'discussion'),
    [tabs],
  );

  useEffect(() => {
    if (baseUrl && hasDiscussionsTab) {
      dispatch(getCourseDiscussionTopics(courseId));
    }
  }, [baseUrl, courseId, dispatch, hasDiscussionsTab]);

  if (!topic?.id || !topic?.enabledInContext) {
    return null;
  }

  const discussionsUrl = `${baseUrl}/${courseId}/category/${unitId}`;

  return (
    <section className="inline-discussions w-100 mb-4" aria-label={intl.formatMessage(messages.discussionsTitle)}>
      <iframe
        src={`${discussionsUrl}?inContextSidebar&inContextInline`}
        className="inline-discussions-frame d-flex w-100 border border-light-400 rounded-sm"
        title={intl.formatMessage(messages.discussionsTitle)}
        allow="clipboard-write"
        loading="eager"
      />
    </section>
  );
};

InlineDiscussions.propTypes = {
  courseId: PropTypes.string.isRequired,
  unitId: PropTypes.string,
};

InlineDiscussions.defaultProps = {
  unitId: null,
};

export default InlineDiscussions;
